export const MALE = "0";
export const FEMALE = "1";
export const APPELLATION = {
  [MALE]: "先生",
  [FEMALE]: "女士"
};

export default {
  [MALE]: "男",
  [FEMALE]: "女"
}